import React from 'react';
import { connect } from 'react-redux';

// Components

import {
  LeadpagesIntegrationForm,
  CenterBlock,
  PageWrapper,
  PageTitle,
  Page
} from '../../../../components';

// Action creators

import {
  fetchIntegrationById,
  getLeadpagesToken,
  addNewIntegration,
  editIntegration
} from '../../../../store/actionCreators/integrations';

// Action types

import {
  GET_LEADPAGES_TOKEN_NETWORK,
  EDIT_INTEGRATION_NETWORK,
  ADD_NEW_INTEGRATION_NETWORK
} from '../../../../store/actionTypes/integrations';

// ----------------

class InstapageIntegrationPage extends Page {
  // Route config

  static title = 'Instapage integration';
  static path = '/main/(new-integration|edit-integration)/leadpages/:id?';
  static exactPath = true;
  static accessWithSubscription = true;

  // Data

  mount = !this.props.match.params.id
    ? [
        {
          ac: getLeadpagesToken
        }
      ]
    : [
        {
          ac: fetchIntegrationById,
          payload: { id: this.props.match.params.id },
          find: { key: 'id', value: this.props.match.params.id },
          mapState: ['integrations', 'integrations']
        }
      ];

  // Bind methods

  pageContent = this.pageContent.bind(this);

  // -------- Methods --------

  // Render

  pageContent() {
    const integrationId = this.props.match.params.id;
    const {
      generatingTokenProcess,
      addNewIntegration,
      editIntegration,
      networkProcess,
      leadpagesMeta,
      integrations
    } = this.props;

    return (
      <PageWrapper>
        <PageTitle>Leadpages</PageTitle>
        <CenterBlock withPadding>
          <LeadpagesIntegrationForm
            generatingTokenProcess={generatingTokenProcess}
            networkProcess={networkProcess}
            integrationId={integrationId}
            submitAction={integrationId ? editIntegration : addNewIntegration}
            data={
              integrationId ? integrations.find(lead => lead.id === +integrationId) : leadpagesMeta
            }
          />
        </CenterBlock>
      </PageWrapper>
    );
  }
  // Render

  render() {
    return this.securRenderPage(this.pageContent);
  }
}

export default connect(
  state => ({
    generatingTokenProcess: state.network[GET_LEADPAGES_TOKEN_NETWORK],
    leadpagesMeta: state.integrations.leadpagesMeta,
    integrations: state.integrations.integrations,
    networkProcess:
      state.network[ADD_NEW_INTEGRATION_NETWORK] || state.network[EDIT_INTEGRATION_NETWORK]
  }),
  {
    addNewIntegration,
    editIntegration
  }
)(InstapageIntegrationPage);
